module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAKCAYAAACXDi8zAAAAXUlEQVQYV4XPMQqDYAwG0CcoPYKTdujq3vtfQ8QDiNLNn24SSIeCYiDTI1+SCm98MWKXVWFAiwUTSljAA332mpMlIKrBM3HD/IPAOvGFzy2cRsXyyO/wt/zy3NMHD5OoGI//P2XdAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/downBeforeIcon.png
// module id = Qqea
// module chunks = 2